import React, { useContext, useState, useEffect } from 'react'
import { PlayerProfileContext } from '../../Context'
import { Box } from '../../Components/Layout'
import { SectionHeading } from '../../Components/Headers'
import { FeedCardList } from '../../Components/Feed'
import { FeedItem } from '../../Api'
import { AdUnit } from '../../Components/Ads/AdUnit'

export const MediaTab: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { team, media: plrMedia } = useContext(PlayerProfileContext)!
  const color = team?.teamColor || undefined
  const [media, setMedia] = useState<FeedItem[]>(plrMedia)

  useEffect(() => {
    if (plrMedia.length > 0) {
      setMedia(plrMedia)
    }
  }, [plrMedia])

  return (
    <>
      <Box>
        <SectionHeading headingText="In the news" teamColor={color} />
        {media.length > 0 && (
          <FeedCardList feedItems={media} section={'player_media_feed'} />
        )}
      </Box>
      <AdUnit bannerType="bannerSecond" aria-label="Player media ad second" />
      <AdUnit bannerType="bannerThird" aria-label="Player media ad third" />
    </>
  )
}
